// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {queryForRepos} from '@github-ui/copilot-chat/components/TaskChatInputToolbar'
import {useCallback} from 'react'

/**
 * Hook that provides a repository loader function that automatically includes
 * a repository owner as defaultOwner for organization-scoped searches
 *
 * @param defaultOwner Owner login to use for scoped repository searches
 * @param repoToIncludeInTopRepos Optional repository (in owner/repo format) to always include in top results
 * when query is empty
 */
export function useDefaultOwnerAwareRepositoryLoader(defaultOwner?: string, repoToIncludeInTopRepos?: string) {
  return useCallback(
    (query: string) => {
      // Pass the provided defaultOwner for organization-scoped searches
      // This works for both organizations and users since the backend supports both
      return queryForRepos(query, defaultOwner, repoToIncludeInTopRepos)
    },
    [defaultOwner, repoToIncludeInTopRepos],
  )
}
